import React from "react";
import { Localize } from "components/service";
import errorNotification from "./error-notification";

// Keep the existing notification appearance, including errors without GraphQL extensions.
const notifyMutationError = (error) => {
    if (error?.graphQLErrors?.length) {
        errorNotification({
            graphQLErrors: error.graphQLErrors.map(({ message, extensions = {} }) => ({
                message,
                extensions: {
                    ...extensions,
                    reason: extensions.reason || Object.values(extensions.validation || {}).flat().join(" "),
                },
            })),
        });
        return;
    }

    errorNotification({
        label: <Localize>APP_SETTINGS.Error_Title</Localize>,
        reason: error?.reason || error?.message || <Localize>APP_SETTINGS.Error_Retry</Localize>,
    });
};

export default notifyMutationError;
